export default {
    footer: 'home_scene_footer',
};
